import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Tabs, Tab } from "react-bootstrap";
import { openCustomModal, closeCustomModal } from "components/custom/modals";
import ConfirmModal from "components/common/confirm-modal";
import TabContactInformation from "components/menu/profile/tabContactInformation";
import TabTravelPreferences from "components/menu/profile/tabTravelPreferences";
import TabGeneralAvailability from "components/menu/profile/tabGeneralAvailability";
import TabSpecialAvailability from "components/menu/profile/tabSpecialAvailability";

import {
    fetchProvinces,
    clearCities
} from "api/menu/master-files/locations/actions";

const tabs = {
    contactInfo: "Contact Information",
    travelPreferences: "Travel Preferences",
    generalAvailability: "General Availability",
    specialAvailability: "Special Availability",
};

const Profile = (props) => {
    const defaultUnsavedData = {
        contactInfo: false,
        travelPreferences: false,
        generalAvailability: false,
        specialAvailability: false
    };

    const {
        openCustomModal,
        closeCustomModal,
        user,
        fetchProvinces
    } = props;
    const [activeTab, setActiveTab] = useState(tabs.contactInfo);
    const [unsavedData, setUnsavedData] = useState(defaultUnsavedData);

    useEffect(() => {
        fetchProvinces(1);
    }, [fetchProvinces]);

    useEffect(() => () => {
        clearCities();
    }, [clearCities]);

    const openConfirmModal = (tab, callback) => {
        const modalObj = {
            modalSettings: {
                size: "sm",
                width: 300
            },
            header: false,
            children: (
                <ConfirmModal
                    title="Do you want to save changes?"
                    onCancel={() => {
                        setActiveTab(tab);
                        setUnsavedData(defaultUnsavedData);
                        closeCustomModal(modalObj);
                    }}
                    onConfirm={() => {
                        callback(); // todo maybe need success callback before change tab
                        setUnsavedData(defaultUnsavedData);
                        setActiveTab(tab);
                        closeCustomModal(modalObj);
                    }}
                    confirmButtonTitle="Yes"
                    cancelButtonTitle="No"
                />
            ),
            handleClose: () => closeCustomModal(modalObj)
        };
        openCustomModal(modalObj);
    },
        onChangeTab = (tab) => {
            const unsavedTabName = Object.keys(unsavedData)
                .find(perTab => typeof unsavedData[perTab] === "function");
            if (unsavedTabName) {
                openConfirmModal(tab, unsavedData[unsavedTabName]);
            } else {
                setActiveTab(tab);
            }
        },
        unsavedDataSet = (tab, statusOrFunction) => {
            const newUnsavedData = Object.assign({}, unsavedData);
            newUnsavedData[tab] = statusOrFunction;
            setUnsavedData(newUnsavedData);
        };

    return (
        <div className="container">
            <h2>{`Profile - ${user.given_name} ${user.family_name}`}</h2>
            <div className="mb-5">Make updates to your profile as needed below</div>

            <Tabs
                id="profile-tabs"
                defaultActiveKey={tabs.contactInfo}
                activeKey={activeTab}
                className="w-100"
                unmountOnExit={true}
                onSelect={tab => onChangeTab(tab)}
            >
                <Tab
                    eventKey={tabs.contactInfo}
                    title={tabs.contactInfo}
                >
                    <TabContactInformation
                        setUnsaved={(status) => unsavedDataSet("contactInfo", status)}
                    />
                </Tab>
                <Tab
                    eventKey={tabs.travelPreferences}
                    title={tabs.travelPreferences}
                >
                    <TabTravelPreferences
                        setUnsaved={(status) => unsavedDataSet("travelPreferences", status)}
                    />
                </Tab>
                <Tab
                    eventKey={tabs.generalAvailability}
                    title={tabs.generalAvailability}
                >
                    <TabGeneralAvailability
                        setUnsaved={(status) => unsavedDataSet("generalAvailability", status)}
                    />
                </Tab>
                <Tab
                    eventKey={tabs.specialAvailability}
                    title={tabs.specialAvailability}
                >
                    <TabSpecialAvailability />
                </Tab>
            </Tabs>
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.auth.user,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    fetchProvinces: bindActionCreators(fetchProvinces, dispatch),
    clearCities: bindActionCreators(clearCities, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Profile);
